export const chainIdByName = {
  shibuya: 81,
  shiden: 336,
}
